import React from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-100 p-6 text-center">
      <h1 className="text-6xl font-extrabold text-green-500 mb-4">404</h1>
      <h2 className="text-2xl font-semibold text-gray-800 mb-2">Page Not Found</h2>
      <p className="text-gray-600 mb-6 max-w-md">
        The page you're looking for doesn't exist or has been moved. Check the URL or return to the dashboard.
      </p>
      <Link
        to="/"
        className="px-6 py-3 bg-green-500 hover:bg-green-600 text-white rounded-lg font-semibold shadow transition"
      >
        Go to Login
      </Link>
    </div>
  );
}